import { useState, useEffect, Fragment } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import InputMask from "react-input-mask";
import { Server } from "../../constants";
import axios from "axios";
import Swal from "sweetalert2";
import Spinner from "../spinner/Spinner";

const listaAños = [
    2015,
    2016,
    2017,
    2018,
    2019,
    2020,
    2021,
    2022,
]

function ModalContactoSeguroHyundai({ setShow, show }) {
    const handleClose = () => setShow(false);
    const [nombre, setNombre] = useState("")
    const [telefono, setTelefono] = useState("")
    const [email, setEmail] = useState("")
    const [listaCiudades, setListaCiudades] = useState([])
    const [ciudadSeleccionada, setCiudadSeleccionada] = useState("0")
    const [nombreCiudad, setNombreCiudad] = useState("")
    const [modeloSeleccionado, setModeloSeleccionado] = useState("")
    const [anioModelo, setAnioModelo] = useState("0")
    const [comentario, setComentario] = useState("")
    const [activeSpinner, setActiveSpinner] = useState(false);
    const emailRegex = new RegExp(
        "^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$"
    );
    const letrasRegex = new RegExp("^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$");

    useEffect(() => {
        if (listaCiudades.length < 1) {
            obtenerCiudades();
        }
    }, [listaCiudades]);

    const obtenerCiudades = async () => {
        const url = `${Server}/api/empresas/getCiudadesHyndai`;
        const resultado = await axios.get(url);
        setListaCiudades(resultado.data.data)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setInterval(setActiveSpinner(true));
        if (!emailRegex.test(email)) {
            setActiveSpinner(false);
            Swal.fire({
                title: "Error",
                text: "El campo Email no tiene el formato Correcto...",
                showCloseButton: true,
                icon: "error",
            });
        } else if (!letrasRegex.test(nombre)) {
            setActiveSpinner(false);
            Swal.fire({
                title: "Error",
                text: "El campo Nombre solo acepta caracteres Alfabeticos...",
                showCloseButton: true,
                icon: "error",
            });
        } else if (
            modeloSeleccionado === "" ||
            anioModelo === "0" ||
            ciudadSeleccionada === "0"
        ) {
            setActiveSpinner(false);
            Swal.fire({
                title: "Error",
                text: "Verifique los Campos de Modelo, Año, o Ciudad",
                showCloseButton: true,
                icon: "error",
            });
        } else {
            const dataForm = new FormData();
            dataForm.append("seg_nombre_interesado", nombre);
            dataForm.append("seg_telefono_interesado", telefono);
            dataForm.append("seg_email_interesado", email);
            dataForm.append("seg_ciudad_id", ciudadSeleccionada);
            dataForm.append("seg_ciudad_nombre", nombreCiudad);
            dataForm.append("seg_modelo_vh", modeloSeleccionado);
            dataForm.append("seg_modelo_anio", anioModelo);
            dataForm.append("seg_comentarios", comentario);
            dataForm.append("seg_extra", "");
            await guardarCotizacion(dataForm);
        }
    }

    const leerAnioModelo = (e) => {
        setAnioModelo(e.target.value)
    }

    const leerCiudad = (e) => {
        setCiudadSeleccionada(e.target.value)
        setNombreCiudad(e.target.options[e.target.selectedIndex].text)
    }

    const guardarCotizacion = async (data) => {
        const url = `${Server}/api/seguro/guardar`
        await axios.post(url,
            data
        ).then(
            respuesta => {
                if (respuesta.status === 200) {
                    if (respuesta.data.status) {

                        setActiveSpinner(false);
                        Swal.fire({
                            title: "Cotización enviada",
                            text: "En breve te contactará uno de nuestros asesores...",
                            showCloseButton: true,
                            icon: "success",
                        });
                        setShow(false);
                        limpiarModal();
                    }
                }
            }
        ).catch(err => {
            Swal.fire({
                title: "Error al enviar la información",
                text: "Intente en unos Minutos...",
                showCloseButton: true,
                icon: "error",
            })
            setActiveSpinner(false)
        })
    }

    const limpiarModal = () => {
        setNombre("")
        setTelefono("")
        setEmail("")
        setCiudadSeleccionada("0")
        setModeloSeleccionado("")
        setAnioModelo("0")
        setComentario("")
    }

    return (
        <Fragment>
            <Modal show={show} onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <Container className="formulario cont-70">
                        <Row>
                            <Col md={12} className="mt-3">
                                <Form onSubmit={handleSubmit} id="formularioContacto">
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} md="12" className="my-auto">
                                            <Form.Label className="contacto-modelo">
                                                Contáctanos
                                            </Form.Label>
                                        </Form.Group>
                                        <Form.Group as={Col} md="12" className="my-auto">
                                            <Form.Label className="d-none d-sm-block">
                                                Nombre
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="nombre"
                                                name="nombre"
                                                placeholder="Nombre"
                                                required
                                                value={nombre}
                                                onChange={(e) => setNombre(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} md="12" className="my-auto">
                                            <Form.Label className="d-none d-sm-block">
                                                Teléfono
                                            </Form.Label>
                                            <InputMask
                                                type="text"
                                                id="telefono"
                                                name="telefono"
                                                placeholder="Teléfono"
                                                className="form-control"
                                                required
                                                value={telefono}
                                                onChange={(e) => setTelefono(e.target.value)}
                                                mask="099 999 9999 999"
                                                maskChar=" "
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} md="12" className="my-auto">
                                            <Form.Label className="d-none d-sm-block">
                                                Email
                                            </Form.Label>
                                            <Form.Control
                                                type="email"
                                                id="email"
                                                name="email"
                                                placeholder="Email"
                                                required
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} md="12" className="my-auto">
                                            <Form.Label className="d-none d-sm-block">
                                                Ciudad
                                            </Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="ciudad"
                                                id="ciudad"
                                                className="custom-select"
                                                value={ciudadSeleccionada}
                                                onChange={leerCiudad}
                                            >
                                                <option disabled value={0} key={0}>
                                                    - Ciudad -
                                                </option>
                                                {
                                                    listaCiudades.map((ciudad) =>
                                                    (
                                                        <option key={ciudad.CIU_CODIGO}
                                                            value={ciudad.CIU_CODIGO}>{ciudad.CIU_NOMBRE}</option>
                                                    )
                                                    )
                                                }

                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} md="12" className="my-auto">
                                            <Form.Label className="d-none d-sm-block">
                                                Modelo
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="modelo"
                                                name="modelo"
                                                placeholder="Modelo"
                                                required
                                                value={modeloSeleccionado}
                                                onChange={(e) => setModeloSeleccionado(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} md="12" className="my-auto">
                                            <Form.Label className="d-none d-sm-block">
                                                Año modelo
                                            </Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="aniomodelo"
                                                id="aniomodelo"
                                                className="custom-select"
                                                value={anioModelo}
                                                onChange={leerAnioModelo}
                                            >
                                                <option disabled value={0} key={0}>
                                                    - Año -
                                                </option>
                                                {listaAños.map((anio) => (
                                                    <option
                                                        key={anio}
                                                        value={anio}
                                                    >
                                                        {anio}
                                                    </option>
                                                ))
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} md="12" className="my-auto">
                                            <Form.Label className="d-none d-sm-block">
                                                Comentarios
                                            </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows="2"
                                                id="comentario"
                                                name="comentario"
                                                value={comentario}
                                                onChange={(e) => setComentario(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    {activeSpinner ? (
                                        <Row className="my-auto mt-4">
                                            <Col md={12} className="mt-4">
                                                <Spinner />
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Form.Row className="mt-2">
                                            <Form.Group
                                                as={Col}
                                                xs="6"
                                                md="6"
                                                className="text-right mt-3"
                                            >
                                                <Button
                                                    className="btn-cerrar"
                                                    variant="secondary"
                                                    onClick={handleClose}
                                                >
                                                    Cerrar
                                                </Button>
                                            </Form.Group>
                                            <Form.Group
                                                as={Col}
                                                xs="6"
                                                md="6"
                                                className="text-left mt-3"
                                            >
                                                <Button
                                                    type="submit"
                                                    className="btn-enviar"
                                                    variant="primary"
                                                >
                                                    Enviar
                                                </Button>
                                            </Form.Group>
                                        </Form.Row>
                                    )
                                    }
                                </Form>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
}
export default ModalContactoSeguroHyundai